import classNames from 'classnames'
import { Step } from 'components/types'

interface ProgressBarProps {
  steps: Step[]
  currentStep: string
  /** When true, the step label below the bar is hidden. */
  hideLabel?: boolean
}

const ProgressBar = ({ steps, currentStep, hideLabel = false }: ProgressBarProps) => (
  <div className="flex flex-col items-center p-2">
    <div className="flex flex-row w-full">
      {steps.map((step, index) => {
        const isActive = step.name === currentStep
        const isCompleted = steps.findIndex(s => s.name === currentStep) > index

        return (
          <div
            key={step.name}
            className={classNames(
              `w-[${(1 / steps.length) * 100}%]`,
              'flex flex-grow items-center justify-center relative'
            )}
          >
            {index > 0 && (
              <span
                className={classNames(
                  'absolute right-1/2 w-1/2 top-4 transform -translate-y-1/2 flex-grow h-1 bg-gray-300 z-0',
                  { 'bg-imovPrimary': isActive || isCompleted }
                )}
              ></span>
            )}

            <div
              className={classNames(
                'flex flex-col items-center text-gray-500 z-20',
                {
                  'text-imovPrimary': isActive || isCompleted,
                }
              )}
            >
              <div
                className={classNames(
                  'flex items-center justify-center w-8 h-8 font-bold rounded-full border-4 border-gray-300 bg-gray-300',
                  {
                    'border-imovPrimary text-imovPrimary bg-white': isActive,
                    'border-imovPrimary bg-imovPrimary text-white': isCompleted,
                  }
                )}
              >
                {index + 1}
              </div>
            </div>

            {index + 1 < steps.length && (
              <span
                className={classNames(
                  'absolute left-1/2 w-1/2 top-4 transform -translate-y-1/2 flex-grow h-1 bg-gray-300',
                  { 'bg-imovPrimary': isActive || isCompleted }
                )}
              ></span>
            )}
          </div>
        )
      })}
    </div>

    {!hideLabel && (
      <div className="mt-2 px-2 text-lg font-bold text-imovPrimary capitalize border-b-2 border-imovPrimary">
        {steps.find(step => step.name === currentStep)?.label}
      </div>
    )}
  </div>
)

export default ProgressBar
